import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Shield, Lock, Eye, Zap } from 'lucide-react';
import heroBg from '../assets/hero-bg.jpg';
import logo from '../assets/icon.ico';  

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="gradient-overlay" />
      
      {/* Grid Pattern */}
      <div className="absolute inset-0 grid-pattern z-2" />
      
      {/* Content */}
      <div className="container relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-2 mt-10"
          >
            <div className="inline-flex items-center justify-center w-84 h-84 mb-4 p-1">
            <img src={logo} alt="CIARL Logo" className="w-84 h-84" />

            </div>
          </motion.div>
          
          {/* Main Heading
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="heading-font text-6xl md:text-8xl font-bold mb-6 leading-tight"
          >
            <span className="text-royal-gold">CIARL</span>
          </motion.h1> */}
          
          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-xl md:text-2xl text-gold-light mb-8 mr-2 ml-2 font-light tracking-wide"
          >
            Leaders in Digital Intelligence through Innovation
          </motion.p>
                    
          {/* Feature Icons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            className="grid grid-cols-2 gap-4 place-items-center sm:flex sm:flex-row sm:justify-center sm:items-center sm:space-x-8 mb-12"
          >
            <div className="flex items-center space-x-2 text-royal-gold">
              <Shield className="w-6 h-6" />
              <span className="text-sm font-medium">Cyber Security</span>
            </div>
            <div className="flex items-center space-x-2 text-royal-gold">
              <Eye className="w-6 h-6" />
              <span className="text-sm font-medium">Intelligence</span>
            </div>
            <div className="flex items-center space-x-2 text-royal-gold">
              <Lock className="w-6 h-6" />
              <span className="text-sm font-medium">Forensics</span>
            </div>
            <div className="flex items-center space-x-2 text-royal-gold">
              <Zap className="w-6 h-6" />
              <span className="text-sm font-medium">Innovation</span>
            </div>
          </motion.div>
          
          
        </motion.div>
      </div>
      
     
    </section>
  );
};

export default HeroSection;